import Repository from './Repository.js'

import { getHeaders } from '@/legacy/repositories/advertiserRepository.js'

export const CampaignRepository = {
  fetchCampaign(id: string, token: string, includes?: string[]) {
    return Repository(getHeaders(token)).get(`/v2/offers/${id}`, {
      params: includes?.length ? { 'include[]': includes } : undefined,
    })
  },
  createCampaign(body: never, storeId: string, token: string) {
    return Repository(getHeaders(token)).post(`/v2/stores/${storeId}/offers`, body)
  },
  updateCampaign(body: never, id: string, token: string) {
    return Repository(getHeaders(token)).put(`/v2/offers/${id}`, body)
  },
  updateCampaignLogo(body: File, id: string, token: string) {
    return Repository(getHeaders(token, true)).post(`/v2/offers/${id}/uploads`, body)
  },
  updateCampaignUsersInvite(
    body: {
      emails: string[]
      user_tag_ids: number[]
      user_ids: number[]
      client_ids: number[]
      revenue_tier_ids: number[]
      social_media_identifiers: number[]
      store_group_ids: number[]
    },
    id: string,
    token: string,
  ) {
    return Repository(getHeaders(token)).post(`/v2/offers/${id}/targets`, body)
  },
  getTargets(id: string, token: string) {
    return Repository(getHeaders(token)).get(`/v2/offers/${id}/targets`)
  },
}
